import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { AvatarConfiguration } from "../Config"


const cogSvcRegion = AvatarConfiguration.cogSvcRegion;
const cogSvcSubKey = AvatarConfiguration.cogSvcSubKey;
const voiceName = AvatarConfiguration.voiceName;
const avatarCharacter = AvatarConfiguration.avatarCharacter;
const avatarStyle = AvatarConfiguration.avatarStyle;
const avatarBackgroundColor = AvatarConfiguration.avatarBackgroundColor;
const avatarCodec = AvatarConfiguration.videoCodec;


export const createWebRTCConnection = (iceServerUrl, iceServerUsername, iceServerCredential) => {

    var peerConnection = new RTCPeerConnection({
        iceServers: [{
            urls: [ iceServerUrl ],
            username: iceServerUsername,
            credential: iceServerCredential
        }]
    })

    return peerConnection;

}



export const createAvatarSynthesizer = (codec) => {

    const speechSynthesisConfig = SpeechSDK.SpeechConfig.fromSubscription(cogSvcSubKey, cogSvcRegion)

    speechSynthesisConfig.speechSynthesisVoiceName = voiceName;
 
    const videoFormat = new SpeechSDK.AvatarVideoFormat(codec,2000000,800,600);

    /*
    let videoCropTopLeftX =  650;
    let videoCropBottomRightX = 1320;
    videoFormat.setCropRange(new SpeechSDK.Coordinate(videoCropTopLeftX, 0), new SpeechSDK.Coordinate(videoCropBottomRightX, height - 75));
    */

    const talkingAvatarCharacter = avatarCharacter
    const talkingAvatarStyle = avatarStyle

    const avatarConfig = new SpeechSDK.AvatarConfig(talkingAvatarCharacter, talkingAvatarStyle, videoFormat)
    avatarConfig.backgroundColor = avatarBackgroundColor;


    let avatarSynthesizer = new SpeechSDK.AvatarSynthesizer(speechSynthesisConfig, avatarConfig)

    avatarSynthesizer.avatarEventReceived = function (s, e) {
        var offsetMessage = ", offset from session start: " + e.offset / 10000 + "ms."
        if (e.offset === 0) {
            offsetMessage = ""
        }
        console.log("[" + (new Date()).toISOString() + "] Event received: " + e.description + offsetMessage)
    }

    return avatarSynthesizer;

}